import { useToast } from '@/src/listings/components/_shared/contexts/ToastContext';
import { Toast } from '@/src/listings/components/_shared/Toast/Toast';
import styles from './ConverstionBarWrapper.module.scss';

interface ConversionBarWrapperProps {
  children: React.ReactNode;
}

export const ConversionBarWrapper: React.FC<ConversionBarWrapperProps> = ({ children }) => {
  const { shouldShowToast } = useToast();

  return (
    <div className={styles.conversionBarWrapper}>
      {children}
      {shouldShowToast && <Toast position="belowConversionBar" />}
    </div>
  );
};
